<template>
    <div class="partner">
        <div class="business-summary">
            <div class="business-card sales-card">
                <div class="business-icon"><img class="business-icon-svg sales-icon-svg" :src="salesIcon" alt="销售金额" /></div>
                <div class="business-content"><div class="business-value">{{ businessData.saleAmount ?? '-' }}</div><div class="business-label">销售金额</div></div>
            </div>
            <div class="business-card cost-card">
                <div class="business-icon"><img class="business-icon-svg cost-icon-svg" :src="costIcon" alt="成本金额" /></div>
                <div class="business-content"><div class="business-value">{{ businessData.costAmount ?? '-' }}</div><div class="business-label">成本金额</div></div>
            </div>
            <div class="business-card profit-card">
                <div class="business-icon"><img class="business-icon-svg profit-icon-svg" :src="profitIcon" alt="利润金额" /></div>
                <div class="business-content"><div class="business-value">{{ businessData.netProfit ?? '-' }}</div><div class="business-label">利润金额</div></div>
            </div>
            <div class="business-card margin-card">
                <div class="business-icon"><img class="business-icon-svg margin-icon-svg" :src="marginIcon" alt="平均毛利率" /></div>
                <div class="business-content"><div class="business-value">{{ businessData.avgGrossMarginRate ?? '-' }}</div><div class="business-label">平均毛利率</div></div>
            </div>
        </div>
        <div>
            <div class="header_btn" @keyup.enter="searchBtn">
                <el-input class="common_ipt" v-model="name" placeholder="请输入会员姓名" clearable />
                <el-input class="common_ipt" v-model="username" placeholder="请输入会员编码" clearable />
                <el-select class="common_ipt" ref="selectRef" v-model="organizationName" placeholder="请选择所属组织"
                    @focus="closeIt" @click="multiple" @change="handleOrganizationChange" clearable>
                </el-select>
                <el-input class="common_ipt" v-model="orderNo" placeholder="请输入订单编号" clearable />
                <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="订单开始时间"
                    end-placeholder="订单结束时间" size="large" style="width: 400;margin:0 10px 10px 0;" clearable
                    :disabled-date="disabledDate" />
                <el-input class="common_ipt" v-model="receiverName" placeholder="请输入收货人" clearable />
                <el-input class="common_ipt" v-model="receiverMobile" placeholder="请输入收货人手机号" clearable />
                <!-- <el-select class="force-style-input " v-model="orderType" placeholder="请选择订单状态" size="large" clearable
                    style="width: 220px;margin-right: 10px;">
                    <el-option label="全部" value="0" />
                    <el-option label="待推送" value="1" />
                    <el-option label="待发货" value="2" />
                    <el-option label="待收货" value="3" />
                    <el-option label="已完成" value="4" />
                    <el-option label="已取消" value="5" />
                    <el-option label="已退款" value="6" />
                </el-select> -->
                <el-select class="force-style-input " v-model="payType" placeholder="请选择支付方式" size="large" clearable
                    style="width: 220px;margin-right: 10px;">
                    <el-option label="积分支付" value="1" />
                    <el-option label="现金支付" value="3" />
                    <el-option label="积分加现金支付" value="4" />
                </el-select>
                <el-select class="force-style-input " v-model="partnerKeyword" placeholder="请选择合作方" size="large"
                    clearable style="width: 220px;margin-right: 10px;">
                    <el-option :label="item.partnerName" :value="item.partnerCode" v-for="(item, index) in partnerList"
                        :key="index" />
                </el-select>

                <el-button size="large" style="margin:0 0 10px 0;" @click="resetBtn">重置</el-button>
                <el-button type="primary" size="large" style="margin:0 0 10px 10px;" :loading="showLoading"
                    @click="searchBtn"><el-icon class="cancelgu">
                        <Search />
                    </el-icon>搜索</el-button>
            </div>
        </div>
        <div class="cooperate">
            <!-- <div class="statistics">统计：{{ count }}条</div> -->
            <div class="statistics-actions">
                <el-dropdown split-button type="primary" size="default" @click="exportOrder" @command="handleExportCommand">
                    <img class="export-icon" :src="exportIcon" alt="" />导出
                    <template #dropdown>
                        <el-dropdown-menu class="export-dropdown-menu">
                            <el-dropdown-item command="orderExport">订单导出</el-dropdown-item>
                            <el-dropdown-item command="goodsDetailExport">商品明细导出</el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
                <el-button type="primary" size="default" @click="toExportTask"><el-icon class="export-task-icon"><Document /></el-icon>导出任务</el-button>
            </div>
        </div>
        <div class="order-type-badges">
            <el-badge v-for="item in orderTypeCounts" :key="item.orderType" :value="item.count ?? 0" :max="badgeMax" :show-zero="true" class="item" :type="orderTypeBadgeType(item.orderType)">
                <el-button :type="Number(orderType) === Number(item.orderType) ? 'primary' : ''" @click="handleOrderTypeClick(item.orderType)">{{ item.orderTypeName }}</el-button>
            </el-badge>
        </div>

        <el-table ref="tableRef" class="manage-list-table" :data="filterTableData"
            style="width: 100%" :fit="true" row-key="unionId" border
            :header-cell-style="{ background: '#F5F7FA' }" :empty-text="texts">
            <!-- 会员姓名   -->
            <el-table-column fixed label="会员姓名  " prop="name" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true' min-width="180">
            </el-table-column>
            <!-- 会员编码  -->
            <el-table-column label="会员编码 " prop="username" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true' min-width="200">
            </el-table-column>
            <!-- 所属组织  -->
            <el-table-column label="所属组织 " prop="unitName" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true' min-width="200">
            </el-table-column>
            <!-- 所属工会  -->
            <el-table-column label="所属工会 " prop="unionName" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true' min-width="200">
            </el-table-column>
            <!-- 所属部门  -->
            <el-table-column label="所属部门 " prop="departmentName" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true'
                min-width="200">
            </el-table-column>
            <!-- 订单编号 -->
            <el-table-column label="订单编号" prop="orderNo" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true' min-width="200">
            </el-table-column>
            <!-- 商品概览  -->
            <el-table-column label="商品概览 " prop="goodsSummary" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true' min-width="300">
            </el-table-column>
            <!-- 收货人手机号 -->
            <el-table-column label="收货人手机号" prop="receiverMobile" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true' min-width="160">
            </el-table-column>
            <!-- 下单时间 -->
            <el-table-column label="下单时间" prop="createTime" :formatter="formatMillisecondsTime" align="center" :show-overflow-tooltip='true' min-width="180">
            </el-table-column>
            <!-- 订单总金额   -->
            <el-table-column label="订单总金额  " prop="orderAmount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true'
                min-width="150">
            </el-table-column>
            <!-- 商品金额   -->
            <el-table-column label="商品金额  " prop="saleAmount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true' min-width="150">
            </el-table-column>
            <!-- 运费金额   -->
            <el-table-column label="运费金额  " prop="freightAmount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true'
                min-width="150">
            </el-table-column>
            <!-- 成本价   -->
            <el-table-column label="成本金额  " prop="costAmount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true' min-width="150">
            </el-table-column>
            <!-- 内部运费成本   -->
            <el-table-column label="内部运费成本  " prop="freightCostAmount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true'
                min-width="150">
            </el-table-column>
            <!-- 支付积分   -->
            <el-table-column label="支付积分  " prop="pointsUsed" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true' min-width="150">
            </el-table-column>
            <!-- 支付金额   -->
            <el-table-column label="支付金额  " prop="cashPayAmount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true'
                min-width="150">
            </el-table-column>
            <!-- 支付方式 -->
            <el-table-column label="支付方式" prop="payType" align="center" :show-overflow-tooltip='true' min-width="180">
                <template #default="scope">
                    <span v-if="isEmptyValue(scope.row.payType)">-</span>
                    <el-tag v-show="scope.row.payType == 1">积分支付</el-tag>
                    <el-tag type="warning" v-show="scope.row.payType == 3">现金支付</el-tag>
                    <el-tag type="success" v-show="scope.row.payType == 4">积分加现金支付</el-tag>
                </template>
            </el-table-column>
            <!-- 订单状态 -->
            <el-table-column label="交易状态" prop="orderStatus" align="center" :show-overflow-tooltip='true' min-width="180">
                <template #default="scope">
                    <span v-if="isEmptyValue(scope.row.orderStatus)">-</span>
                    <el-tag type="warning" v-show="scope.row.orderStatus == 1">待支付</el-tag>
                    <el-tag v-show="scope.row.orderStatus == 2">已支付</el-tag>
                    <el-tag type="success" v-show="scope.row.orderStatus == 3">已完成</el-tag>
                    <el-tag type="info" v-show="scope.row.orderStatus == 4">已关闭</el-tag>
                </template>
            </el-table-column>
            <!-- 分发状态 -->
            <el-table-column label="分发状态" prop="dispatchStatus" align="center" :show-overflow-tooltip='true' min-width="180">
                <template #default="scope">
                    <span v-if="isEmptyValue(scope.row.dispatchStatus)">-</span>
                    <el-tag type="info" v-show="scope.row.dispatchStatus == 10">待推送</el-tag>
                    <el-tag type="success" v-show="scope.row.dispatchStatus == 20">已推送</el-tag>
                    <el-tag v-show="scope.row.dispatchStatus == 30">已取消 </el-tag>
                    <el-tag type="warning" v-show="scope.row.dispatchStatus == 40">部分分发失败</el-tag>
                    <el-tag type="danger" v-show="scope.row.dispatchStatus == 50">分发失败</el-tag>
                </template>
            </el-table-column>
            <!-- 履约状态 -->
            <el-table-column label="履约状态" prop="deliveryStatus" align="center" :show-overflow-tooltip='true' min-width="180">
                <template #default="scope">
                    <span v-if="isEmptyValue(scope.row.deliveryStatus)">-</span>
                    <el-tag type="info" v-show="scope.row.deliveryStatus == 0">待发货</el-tag>
                    <el-tag type="info" v-show="scope.row.deliveryStatus == 1">部分发货</el-tag>
                    <el-tag v-show="scope.row.deliveryStatus == 2">已发货 </el-tag>
                    <el-tag type="success" v-show="scope.row.deliveryStatus == 3">已妥投</el-tag>
                    <el-tag type="warning" v-show="scope.row.deliveryStatus == 4">已拒收</el-tag>
                    <el-tag type="danger" v-show="scope.row.deliveryStatus == 5">发货异常</el-tag>
                </template>
            </el-table-column>
            <!-- 退款状态 -->
            <el-table-column label="退款状态" prop="refundStatus" align="center" :show-overflow-tooltip='true' min-width="180">
                <template #default="scope">
                    <span v-if="isEmptyValue(scope.row.refundStatus)">-</span>
                    <el-tag type="success" v-show="scope.row.refundStatus == 0">未退款</el-tag>
                    <el-tag type="warning" v-show="scope.row.refundStatus == 1">部分退款</el-tag>
                    <el-tag type="danger" v-show="scope.row.refundStatus == 2">全部退款 </el-tag>
                    <el-tag v-show="scope.row.refundStatus == null">未退款</el-tag>
                </template>
            </el-table-column>
            <!-- 毛利率   -->
            <el-table-column label="毛利率  " prop="grossMarginRate" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true'
                min-width="150">
            </el-table-column>
            <!-- 毛利金额   -->
            <el-table-column label="毛利金额  " prop="grossMarginAmount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true'
                min-width="150">
            </el-table-column>
            <!-- 退款后毛利率   -->
            <el-table-column label="退款后毛利率  " prop="netGrossMarginRate" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true'
                min-width="150">
            </el-table-column>
            <!-- 退款后毛利金额   -->
            <el-table-column label="退款后毛利金额  " prop="netGrossMarginAmount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip='true'
                min-width="150">
            </el-table-column>
            <el-table-column fixed="right" label="操作" align="center" min-width="200">
                <template #default="scope">
                    <el-button class="bulur" size="default" @click="toOrderDetail(scope.row.orderNo)"><el-icon class="cancel"><Search /></el-icon>查看订单详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination :hide-on-single-page="true" layout="prev, pager, next,sizes" :page-sizes="[6, 10, 15, 20]"
            :current-page="currentPage" :page-size="pagesize" :total="count" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />

        <div>
            <el-dialog v-model="visible" title="所属组织" width="500px" top="10vh" custom-class="organization-dialog"
                :close-on-click-modal="true" destroy-on-close>
                <el-tree :data="texture" :props="defaultProps" accordion highlight-current @node-click="dendrogram" />
                <template #footer>
                    <el-button type="primary" @click="confirmOrganization">确定</el-button>
                </template>
            </el-dialog>
        </div>
    </div>
</template>

<script>
export default {
    name: 'orderIndex'
}
</script>

<script setup>
import { Document, Search } from '@element-plus/icons-vue'
import { nextTick, onActivated, onBeforeUnmount, ref, onMounted } from 'vue';
import moments from 'moment'
import { ElMessage } from 'element-plus';
import {
    queryOrderList, queryOrganizationList, queryPartnerList,createExportTask
} from "../../../request/api";
import {
    onBeforeRouteLeave,
    useRouter,
} from "vue-router";
import qs from 'qs';
import exportIcon from '../../../assets/daochu.png';
import costIcon from './svg/chengben.svg';
import marginIcon from './svg/lilv.svg';
import profitIcon from './svg/lirun.svg';
import salesIcon from './svg/xiaoshou.svg';
const texts = ref('暂无数据');
const router = useRouter()
const visible = ref(false);
const texture = ref([]);
const defaultProps = {
    label: 'organizationName',
    children: 'children'
}
const name = ref(''); //会员姓名
const username = ref(''); //会员编码
const orderNo = ref(''); //订单编号
const receiverName = ref(''); //收货人
const receiverMobile = ref(''); //收货人手机号

const orderType = ref(0); //订单状态，默认选中全部
const payType = ref(''); //支付方式
const partnerKeyword = ref(''); //合作方
const time = ref([]);
const organizationName = ref(''); //组织名称
const organizationCode = ref(''); //组织编码
const organizationType = ref(''); //组织类型
const currentPage = ref(1);
const pagesize = ref(6);
const filterTableData = ref([]);
const businessData = ref({});
const orderTypeCounts = ref([]);
const badgeMax = Number.MAX_SAFE_INTEGER;
const orderTypeBadgeType = (type) => {
    const value = Number(type);
    if (value === 0) return 'primary';
    if ([1, 2, 3, 4].includes(value)) return 'success';
    if ([5, 6].includes(value)) return 'danger';
    return 'primary';
};
const count = ref(0);
const showLoading = ref(true);
const selectRef = ref(null);
const selectedOrganization = ref(null);
const tableRef = ref(null);
const tableScrollLeft = ref(0);

const refreshTableLayout = () => {
    nextTick(() => {
        tableRef.value?.doLayout?.();
    });
};

const getTableScrollWrap = () =>
    tableRef.value?.scrollBarRef?.wrapRef ||
    tableRef.value?.$el?.querySelector?.('.el-scrollbar__wrap');

const saveTableScrollPosition = () => {
    const scrollWrap = getTableScrollWrap();
    if (scrollWrap) tableScrollLeft.value = scrollWrap.scrollLeft;
};

const restoreTableScrollPosition = () => {
    nextTick(() => {
        tableRef.value?.doLayout?.();
        window.requestAnimationFrame(() => {
            tableRef.value?.setScrollLeft?.(tableScrollLeft.value);
            window.requestAnimationFrame(() => {
                tableRef.value?.setScrollLeft?.(tableScrollLeft.value);
            });
        });
    });
};

const isEmptyValue = (value) => value === null || value === undefined || value === '';

const formatEmptyValue = (row, column, cellValue) => {
    return isEmptyValue(cellValue) ? '-' : cellValue;
};

const formatMillisecondsTime = (row, column, cellValue) => {
    return isEmptyValue(cellValue) ? '-' : moments(Number(cellValue)).format('YYYY-MM-DD HH:mm:ss');
};

// 合作方列表
const partnerList = ref([]);
const dendrogram = (node) => {
    selectedOrganization.value = node;
}

const confirmOrganization = () => {
    if (selectedOrganization.value) {
        organizationCode.value = selectedOrganization.value.organizationCode;
        organizationName.value = selectedOrganization.value.organizationName;
        organizationType.value = selectedOrganization.value.organizationType;
    }
    visible.value = false;
}

const closeIt = () => {
    selectRef.value?.blur();
}

const multiple = () => {
    selectedOrganization.value = null;
    visible.value = true;
}

const handleOrganizationChange = (value) => {
    if (!value) {
        organizationCode.value = '';
        organizationType.value = '';
    }
}

const getOrderQueryParams = () => {
    let orderStartTime = '';
    let orderEndTime = '';
    if (time.value.length === 2) {
        orderStartTime = moments(time.value[0]).startOf('day').valueOf();
        orderEndTime = moments(time.value[1]).endOf('day').valueOf();
    }

    return {
        name: name.value,
        username: username.value,
        organizationCode: organizationCode.value,
        organizationType: organizationType.value,
        orderNo: orderNo.value,
        orderStartTime: orderStartTime,
        orderEndTime: orderEndTime,
        receiverName: receiverName.value,
        receiverMobile: receiverMobile.value,
        orderType: orderType.value,
        payType: payType.value,
        partnerKeyword: partnerKeyword.value
    };
}

const dataInfo = () => {
    const params = {
        ...getOrderQueryParams(),
        pageNum: Number(currentPage.value),
        pageSize: Number(pagesize.value)
    };
    queryOrderList(params).then((res) => {
        if (res.data.code == 0) {
            filterTableData.value = res.data.data.data;
            businessData.value = res.data.data.businessData;
            orderTypeCounts.value = res.data.data.orderTypeCounts || [];
            count.value = res.data.data.total;
            showLoading.value = false;
        } else {
            ElMessage.error(res.data.msg);
        }
    });
}

// 查询组织列表
const getQueryOrganizationList = () => {
    queryOrganizationList().then((res) => {
        if (res.data.code === 0) {
            texture.value = res.data.data;
        } else {
            ElMessage.error(res.data.msg);
        }
    });
}
// 查询合作方列表
const getQueryPartnerList = () => {
    queryPartnerList().then((res) => {
        if (res.data.code === 0) {
            partnerList.value = res.data.data;
        } else {
            ElMessage.error(res.data.msg);
        }
    });
}
// 跳转订单详情
const toOrderDetail = (orderNo) => {
    sessionStorage.setItem('orderNo', orderNo);
    router.push({
        path: '/order/detail',
    })
}

const disabledDate = (time) => {
    return time.getTime() > Date.now();
};

const searchBtn = () => {
    showLoading.value = true;
    currentPage.value = 1;
    dataInfo();
}

const resetBtn = () => {
    name.value = '';
    username.value = '';
    organizationName.value = '';
    organizationCode.value = '';
    organizationType.value = '';
    selectedOrganization.value = null;
    orderNo.value = '';
    receiverName.value = '';
    receiverMobile.value = '';
    time.value = [];
    orderType.value = 0;
    payType.value = '';
    partnerKeyword.value = '';

    currentPage.value = 1;
    pagesize.value = 6;
    showLoading.value = true;
    dataInfo();
}

const handleSizeChange = (val) => {
    showLoading.value = true;
    pagesize.value = val;
    currentPage.value = 1;
    dataInfo();
}

const handleCurrentChange = (val) => {
    currentPage.value = val;
    showLoading.value = true;
    dataInfo();
}

const handleOrderTypeClick = (type) => {
    orderType.value = type;
    currentPage.value = 1;
    showLoading.value = true;
    dataInfo();
}

const reach = (row, column, cellValue) => {
    if (cellValue) {
        return moments(cellValue * 1000).format("YYYY-MM-DD HH:mm")
    }
    return '';
};

const editPartner = () => {
    router.push({ path: '/platform/add' })
}

const toExportTask = () => {
    router.push({ path: '/order/export' });
}

const createOrderExportTask = (exportType) => {
    createExportTask({
        ...getOrderQueryParams(),
        exportType
    }).then((res) => {
        if (res.data.code === 0) {
            ElMessage.success(res.data.msg || '导出任务创建成功');
        } else {
            ElMessage.error(res.data.msg);
        }
    });
}

const exportOrder = () => {
    createOrderExportTask(1);
}

const exportGoodsDetailExport = () => {
    createOrderExportTask(2);
}

const handleExportCommand = (command) => {
    const exportHandlers = { orderExport: exportOrder, goodsDetailExport: exportGoodsDetailExport };
    exportHandlers[command]?.();
}

onMounted(() => {
    dataInfo();
    getQueryOrganizationList();
    getQueryPartnerList();
    window.addEventListener('resize', refreshTableLayout);
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', refreshTableLayout);
});

onActivated(() => {
    restoreTableScrollPosition();
});

onBeforeRouteLeave(() => {
    saveTableScrollPosition();
});
</script>

<style lang="scss" scoped>
/* 修复展开箭头动画 */
::v-deep .el-table__expand-icon {
    transition: transform 0.3s;

    &.el-table__expand-icon--expanded {
        transform: rotate(90deg);
    }
}

/* 确保展开内容区域样式 */
::v-deep .el-table__expanded-cell {
    // padding: 10px !important;
    //   background-color: #fafafa;

    .el-table {
        // margin: 10px 0;
    }
}

::v-deep .el-input__inner {
    height: 40px;
}

/* 与 allocating 页面保持一致的表格表头及行高 */
::v-deep .el-table__header {
    margin: 0 !important;
}

::v-deep .el-table .el-table__cell {
    padding-top: 15px;
    padding-bottom: 15px;
}

.el-pagination {
    margin-top: 10px;
}

.bulur {
    color: #409eff;
    border: none;
    --el-button-bg-color: none;
    --el-button-hover-bg-color: none;
    --el-button-hover-text-color: none;
}

.bulur:hover {
    color: #a0cfff;
}

.cancel {
    margin-right: 5px;
    font-weight: 400;
}

::v-deep .organization-dialog {
    height: 80vh;
    display: flex;
    flex-direction: column;
}

::v-deep .organization-dialog .el-dialog__body {
    height: auto !important;
    padding: 10px 10px 10px 10px !important;
    flex: 1;
    overflow: auto !important;
}

::v-deep .organization-dialog .el-dialog__body::-webkit-scrollbar {
    display: none;
}

.partner {
    height: calc(100vh - 170px);
    background-color: #FFFFFF;
    width: 95%;
    padding: 20px;
    overflow: auto;
    box-shadow: var(--el-box-shadow-light);
    border-radius: 5px;
    margin: 15px auto;
}

.business-summary {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    width: 98%;
    gap: 10px;
    margin: 0 0 20px 0;
}

.business-card {
    display: flex;
    height: 100px;
    min-width: 0;
    overflow: hidden;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.business-icon {
    display: grid;
    flex: 0 0 100px;
    place-items: center;
    color: #fff;
    font-size: 30px;
}

.business-icon-svg {
    display: block;
    width: 42px;
    height: 42px;
    object-fit: contain;
}

.sales-icon-svg { filter: brightness(0) invert(1); }
.cost-icon-svg { filter: brightness(0) invert(1); }
.profit-icon-svg { filter: brightness(0) invert(1); }
.margin-icon-svg { filter: brightness(0) invert(1); }

.business-content {
    display: flex;
    flex: 1;
    min-width: 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 8px;
}

.business-value {
    max-width: 100%;
    overflow: hidden;
    font-size: 25px;
    font-weight: 600;
    line-height: 32px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.business-label { color: #909399; font-size: 14px; line-height: 22px; }
.sales-card .business-icon { background: #ff7b31; }.sales-card .business-value { color: #ff7b31; }
.cost-card .business-icon { background: #1b8ffb; }.cost-card .business-value { color: #1b8ffb; }
.profit-card .business-icon { background: #07c160; }.profit-card .business-value { color: #07c160; }
.margin-card .business-icon { background: #13227a; }.margin-card .business-value { color: #13227a; }

@media (max-width: 1200px) { .business-summary { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 640px) { .business-summary { grid-template-columns: 1fr; }.business-icon { flex-basis: 72px; } }


.header_btn {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    flex-wrap: wrap;
}

.common_ipt {
    width: 220px;
    height: 40px !important;
    margin-right: 10px;
    margin-bottom: 10px;
}

.common_ipt3 {
    width: 220px;
}

.force-style-input {
    height: 40px;
    line-height: 40px;
    margin-bottom: 10px;
}

.statistics {
    font-size: 14px;
    color: #909399;
    // margin-bottom: 15px;
}

.cooperate { margin-bottom: 10px; }
.statistics-actions { display: flex; justify-content: flex-end; gap: 12px; }
.order-type-badges { display: flex; flex-wrap: wrap; gap: 24px; padding: 4px 0 15px; }
.order-type-badges .item { margin-right: 4px; }
.order-type-badges .el-button {
    --el-button-hover-text-color: var(--el-button-text-color);
    --el-button-hover-bg-color: var(--el-button-bg-color);
    --el-button-hover-border-color: var(--el-button-border-color);
    --el-button-active-text-color: var(--el-button-text-color);
    --el-button-active-bg-color: var(--el-button-bg-color);
    --el-button-active-border-color: var(--el-button-border-color);
}
.export-icon { width: 15px; margin-right: 6px; vertical-align: middle; }
.export-task-icon { margin-right: 6px; }
.export-dropdown-menu { min-width: 117px; }
</style>
